import { useModuleGate } from '../../../lib/moduleGate';

/**
 * True when Launch Calendar, supply calendar workbench, and counterfactual
 * levers are available. Canonical gate: time_phased_planning workspace module.
 */
export function useTimePhasedPlanningEnabled(): boolean {
  return useModuleGate('time_phased_planning');
}
